import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../core/service/common-service/common.service';
import { ListCustData } from 'src/app/component/pipeline-management/listCustData';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import * as _moment from 'moment';
import { openPipelineEnquiryTableDialog } from '../pipeline-enquiry-table/pipeline-enquiry-table.component';

const moment = (_moment as any).default ? (_moment as any).default : _moment;

export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY LT',
  datePickerInput: 'LL',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: 'app-pipeline-enquiry',
  templateUrl: './pipeline-enquiry.component.html',
  styleUrls: ['./pipeline-enquiry.component.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS }
  ],
})

export class PipelineEnquiryComponent implements OnInit {
  leadStatusCode: string="";
  leadSubStatusCode: string = "";
  clickedRow: any
  diff: any
  likelyBuyDate: Date
  selected: any
  isClassTwoActive: boolean = true;
  isClassOneActive: boolean = true;
  isClassThreeActive: boolean = true;
  uniqueChassisArray: string[] = [];
  leadStatusValues: string[] = [];
  uniqueProductName: string[] = [];
  uniqueLeadType: string[] = [];
  uniqueSourceValue: string[] = [];
  leadType: string="";
  vin: string="";
  product: string="";
  source: string="";
  buyDate: Date;
  customerCode: string="";
  custResData: ListCustData;
  userId: string="";
  countryCode: string="";
  followUpDate: any;
  enquiryRemarks: string="";
  today:Date =new Date();
  contractNumber:string="";

  ngOnInit() {

    this.commonService.enquiryDialogFilter().subscribe(res => {
      this.uniqueProductName = res['responseData'][0].filterValues;
      this.uniqueLeadType = res['responseData'][1].filterValues;
      this.uniqueSourceValue = res['responseData'][2].filterValues;
    })

    this.userId = localStorage.getItem("userId");
    this.countryCode = localStorage.getItem("countryCode");
  }

  constructor(private commonService: CommonService, private datePipe: DatePipe, private dialogRef: MatDialogRef<PipelineEnquiryComponent>, private toastr: ToastrService, @Inject(MAT_DIALOG_DATA) public data: any, public router: Router, public dialog: MatDialog) {
    this.clickedRow = data.clickedRow;
    this.uniqueChassisArray = data.uniqueChassisArray;
  }

  enableDropDown1(answer) {
    this.followUpDate = '';
    this.leadSubStatusCode = '';
    this.contractNumber = '';
    this.leadStatusCode = answer.value;
    if (answer.value == "211") {
      return this.isClassOneActive = false;
    } else {
      return this.isClassOneActive = true;
    }
  }

  enableDropDown2(answer) {
    this.leadSubStatusCode = '';
    this.leadStatusCode = answer.value;
    if (answer.value == "213") {
      return this.isClassTwoActive = false;
    } else {
      return this.isClassTwoActive = true;
    }
  }

  enableDropDown3(answer) {
    if (answer.value == "212") {
      return this.isClassThreeActive = false;
    } else {
      return this.isClassThreeActive = true;
    }
  }

  onclose() {
    this.dialogRef.close();
  }

  getdiff() {
    var endDate = new Date(this.buyDate);
    var startDate = new Date();
    var Time = endDate.getTime() - startDate.getTime();
    this.diff = (Time / (1000 * 3600 * 24));
    if (this.diff < 15) {
      this.leadType = " Hot";
    }
    if (this.diff >= 15 && this.diff <= 30) {
      this.leadType = " Warm";
    }
    if (this.diff > 30) {
      this.leadType = "Cold";
    }
    return this.diff;
  }

  saveResponse(): void {
  if(this.buyDate == null || (this.vin == null || this.vin =="") || (this.product == null || this.product == "") || (this.source == null || this.source == "") || (this.leadType == null || this.leadType == "") || (this.leadStatusCode == null || this.leadStatusCode == "") || (this.enquiryRemarks == null || this.enquiryRemarks == "")) {
    this.toastr.error("Please fill required fields");
  }
  else{
    this.custResData = new ListCustData(
      this.customerCode = this.clickedRow.customerCode,
      this.vin,
      this.product,
      this.source,
      this.leadType,
      this.datePipe.transform((this.buyDate), "yyyy-MM-dd"),
      this.leadStatusCode,
      this.leadSubStatusCode,
      this.userId,
      this.countryCode,
      this.followUpDate,
      this.enquiryRemarks,
      this.contractNumber
    )
    if(this.isClassOneActive == false && (this.followUpDate == null || this.followUpDate == '')){
      this.toastr.error("Please Fill Required Fields.");
    }else if(this.isClassOneActive == false  && (this.leadSubStatusCode == null || this.leadSubStatusCode == "")){
      this.toastr.error("Please Fill Required Fields.");
    }else if(this.isClassTwoActive == false  && (this.leadSubStatusCode == null || this.leadSubStatusCode == "")){
      this.toastr.error("Please Fill Required Fields.");
    }else if(this.isClassThreeActive == false && (this.contractNumber == null || this.contractNumber == "")){
      this.toastr.error("Please Fill Required Fields.");
    }
    else{
    this.commonService.createPipelineEnquiry(this.custResData).subscribe(
      res => {
        if (res["responseCode"] == 0) {
          this.toastr.info(res["message"], "Success");
          this.dialogRef.close();
          openPipelineEnquiryTableDialog(this.dialog,res['responseData']);
        }
        else {
          this.toastr.error(res["message"], "Error");
          this.dialogRef.close();
        }
      });
    }
  }
}

}

export function openPipelineEnquiryDialog(dialog: MatDialog, clickedRow, uniqueChassisArray) {
  const config = new MatDialogConfig();
  config.disableClose = true;
  config.autoFocus = true;
  config.width = '850px';
  config.height = '500px';
  config.data = {
    clickedRow: clickedRow,
    uniqueChassisArray: uniqueChassisArray,
  };
  const dialogRef = dialog.open(PipelineEnquiryComponent, config);
  return dialogRef.afterClosed();

}

export class custData {
  customerCode: string;
  vin: string;
  product: string;
  source: string;
  leadType: string;
  buyDate: string;
  leadStatusCode: string;
  leadSubStatusCode: string;
  userId: string;
  countryCode: string;
  enquiryId: string;
  followUpDate: string;
  enquiryRemarks: string;
  contractNumber: string

  constructor(
    customerCode,
    vin,
    product,
    source,
    leadType,
    buyDate,
    leadStatusCode,
    leadSubStatusCode,
    userId,
    countryCode,
    enquiryId,
    followUpDate,
    enquiryRemarks,
    contractNumber
  ) {
    this.customerCode = customerCode;
    this.vin = vin;
    this.product = product;
    this.source = source;
    this.leadType = leadType;
    this.buyDate = buyDate;
    this.leadStatusCode = leadStatusCode;
    this.leadSubStatusCode = leadSubStatusCode;
    this.userId = userId;
    this.countryCode = countryCode;
    this.enquiryId = enquiryId;
    this.followUpDate = followUpDate;
    this.enquiryRemarks = enquiryRemarks;
    this.contractNumber = contractNumber;
  }
}

